import React from "react";
import { useTranslation,Trans  } from 'react-i18next';
const Grsf = () => {
      const { t } = useTranslation();
    return (
        <section className="lyt-section" id="mission">
            <div className="container">
                <div className="heading-wrapper typ-mb-160 justify-content-center">
                    <div className="text-center">
                        <h2
                            className="bs-heading typdblue mb-2"
                            data-aos="fade-in"
                            data-aos-delay="200"
                        >
                            {t('ourMissionTitle')}
                        </h2>
                        <p
                            className="bs-para typgrey"
                            data-aos="fade-in"
                            data-aos-delay="300"
                        >
                            {t('ourMissionSubTitle')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="typ-blue-lyt typ-responsive-space">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="typ-quote-box">
                                
                                <i className="icon icon-qutation-top"></i>
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: `${t('ourMissionDesc')}`,
                                    }}
                                />
                                <i className="icon icon-qutation-bottom"></i>
                                
                            </div>
                            {/* <div className="heading-wrapper justify-content-center">
                                <div className="text-center">
                                    <h2
                                        className="bs-heading typwhite mb-2"
                                        data-aos="fade-in"
                                        data-aos-delay="200"
                                    >
                                        Unique Features of the GRSF Platform
                                    </h2>
                                </div>
                            </div>
                            <div className="bs-img-box">
                                <div className="image-wrapper">
                                    <div className="overlay-img"></div>
                                    <div className="item animated wow fadeIn">
                                        <img
                                            className="img-fluid"
                                            src="/images/about/grsf-one.png"
                                            alt="logo"
                                            width={260}
                                            height={400}
                                        />
                                        <h4 className="typ-img-txt">
                                            Access and Identity Management
                                        </h4>
                                        <div className="overlay bottom-overlay">
                                            <div className="text">
                                                Streamlines project planning,
                                                quality control, and
                                                subcontractor management for
                                                efficient execution.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="image-wrapper">
                                    <div className="overlay-img"></div>
                                    <div className="item animated wow fadeIn">
                                        <img
                                            className="img-fluid"
                                            src="/images/about/grsf-two.png"
                                            alt="logo"
                                            width={260}
                                            height={400}
                                        />
                                        <h4 className="typ-img-txt">
                                            Our Community in Action
                                        </h4>
                                        <div className="overlay bottom-overlay">
                                            <div className="text">
                                                Streamlines project planning,
                                                quality control, and
                                                subcontractor management for
                                                efficient execution.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="image-wrapper">
                                    <div className="overlay-img"></div>
                                    <div className="item animated wow fadeIn">
                                        <img
                                            className="img-fluid"
                                            src="/images/about/grsf-three.png"
                                            alt="logo"
                                            width={260}
                                            height={400}
                                        />
                                        <h4 className="typ-img-txt">
                                            Collaboration and Document Sharing
                                        </h4>
                                        <div className="overlay bottom-overlay">
                                            <div className="text">
                                                Streamlines project planning,
                                                quality control, and
                                                subcontractor management for
                                                efficient execution.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="image-wrapper">
                                    <div className="overlay-img"></div>
                                    <div className="item animated wow fadeIn">
                                        <img
                                            className="img-fluid"
                                            src="/images/about/grsf-four.png"
                                            alt="logo"
                                            width={260}
                                            height={400}
                                        />
                                        <h4 className="typ-img-txt">
                                            Secure Voting and Contract
                                            Management
                                        </h4>
                                        <div className="overlay bottom-overlay">
                                            <div className="text">
                                                Streamlines project planning,
                                                quality control, and
                                                subcontractor management for
                                                efficient execution.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Grsf;
